<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <h1 class="page-title pull-left">Ovi Trap Report</h1>
        <sites-loading-progress></sites-loading-progress>
      </div>
    </div>

    <div class="panel" v-if="!loading">
      <div class="panel-body">
        <div class="row panel-heading">
          <form @submit.prevent="">
            <div class="row">
              <div class="col-xs-12 col-sm-6">
                <div class="form-group">
                  <label for="contract">Contract</label>
                  <multiselect
                    v-model="contract"
                    :options="contracts"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="true"
                    :hide-selected="true"
                    track-by="name"
                    placeholder=""
                    :custom-label="customLabel"
                  >
                  </multiselect>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6">
                <div class="form-group">
                  <label for="municipality">Municipality</label>
                  <multiselect
                    v-model="municipality"
                    :options="municipalities"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="true"
                    :hide-selected="true"
                    track-by="name"
                    placeholder=""
                    :custom-label="customLabel"
                  >
                  </multiselect>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6">
                <div class="form-group">
                  <label>Beginning Trap Date</label>
                  <datepicker
                    v-model="startDate"
                    format="yyyy-MM-dd"
                    input-class="form-control"
                  ></datepicker>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6">
                <div class="form-group">
                  <label>Ending Trap Date</label>
                  <datepicker
                    v-model="endDate"
                    format="yyyy-MM-dd"
                    input-class="form-control"
                  ></datepicker>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 text-right">
                <button
                  class="btn btn-primary"
                  type="button"
                  v-on:click="runReport"
                >
                  <i
                    class="fa fa-circle-o-notch fa-spin"
                    v-if="report.loading"
                  ></i>
                  <span v-if="!report.loading">Generate Report</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="panel-body" v-if="report.url">
        <iframe :src="report.url" frameborder="0" scrolling="no"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import loader from "@/utils/loader";
import Datepicker from "vuejs-datepicker";
import Multiselect from 'vue-multiselect'
import sitesLoadingProgress from "@/components/report/sites_loading_progress";;
import ReportsService from "@/services/ReportsService";
import reports from "@/utils/reports";
import report_mixin from "./report_mixin";

export default {
  name: "report-mcs-ovi-trap",

  components: {
    Datepicker,
    sitesLoadingProgress,
    Multiselect,
  },

  mixins: [report_mixin],

  data() {
    return {
      loading: true,
      contract: [],
      municipality: [],
      startDate: reports.monthBegin(),
      endDate: reports.monthEnd(),
      report: {
        loading: false,
        url: null,
      },
    };
  },

  methods: {
    customLabel({ name }) {
      return name;
    },
    runReport() {
      this.report.loading = true;
      this.report.url = null;
      let data = {
        startDate: this.startDate,
        endDate: this.endDate,
        contracts: reports.getId(this.contract),
        municipality: reports.getId(this.municipality),
      };
      ReportsService.report("mcs-ot", data)
        .then((data) => {
          this.report.loading = false;
          this.report.url = data.url;
        })
        .catch((error) => {
          this.report.loading = false;
          toastr.error(
            `Sorry, there was an error generating the report. ${error.message}`
          );
        });
    },
  },

  computed: {
    contracts() {
      return this.$store.getters.forSelect("contracts");
    },
    municipalities() {
      return this.$store.getters.forSelect("municipalities");
    },
  },

  mounted() {
    loader.lookups().then(() => {
      this.loading = false;
    });
  },
};
</script>

<style lang="scss">
iframe {
  width: 100%;
  height: 800px;
  border: none;
}
</style>
